import React from "react";

const Footer = () => (
  <>Copyright © {new Date().getFullYear()} Union Home Mortgage Corporation</>
);

export default Footer;
